import { defineWorld } from "@latticexyz/world";

export const stashConfig = defineWorld({
  namespaces: {
    pesos: {
      tables: {
        Balances: {
          schema: {
            account: "address",
            value: "uint256",
          },
          key: ["account"],
        },
      },
    },
  },
});

export const PesosBalancesTable = stashConfig.namespaces.pesos.tables.Balances;
